export {default as Modal} from './Modal.jsx';



// WEBPACK FOOTER //
// ./lib/rlink-modal/component.jsx